// extracted by mini-css-extract-plugin
module.exports = {"rating-resume":"ExternalProfileTemplate_rating-resume__TCmQw","main-area":"ExternalProfileTemplate_main-area__3IUXx","form-area":"ExternalProfileTemplate_form-area__Eq5tb"};